import React, { useState } from "react";
import { Link } from "react-router-dom";
import { FaFacebook, FaTwitter, FaInstagram, FaLinkedin, FaYoutube } from "react-icons/fa";
import logo from "../assets/ojoto_union_logo.png";

const Footer = () => {
  const currentYear = new Date().getFullYear();
  const [email, setEmail] = useState("");

  const handleNewsletterSubmit = (e) => {
    e.preventDefault();
    // Handle newsletter subscription
    console.log("Newsletter subscription:", email);
    setEmail("");
    alert("Thank you for subscribing to our newsletter!");
  };

  const mainNavLinks = [
    { name: "About", path: "/about" },
    { name: "Careers", path: "/resources/careers" },
    { name: "Contact", path: "/contact" },
    { name: "Get Involved", path: "/get-involved/donor" },
    { name: "Programs", path: "/programs/employability-skills" },
    { name: "News", path: "/resources/news-events" }
  ];

  const socialLinks = [
    { icon: <FaFacebook />, url: "https://facebook.com", label: "Facebook" },
    { icon: <FaTwitter />, url: "https://twitter.com", label: "Twitter" },
    { icon: <FaInstagram />, url: "https://instagram.com", label: "Instagram" },
    { icon: <FaLinkedin />, url: "https://linkedin.com", label: "LinkedIn" },
    { icon: <FaYoutube />, url: "https://youtube.com", label: "YouTube" }
  ];

  return (
    <footer 
      className="border-t border-gray-200"
      style={{
        backgroundColor: '#F9FAFB',
        fontFamily: "'Open Sans', system-ui, sans-serif",
        borderTop: '2px solid #E5E7EB'
      }}
    >
      <div className="max-w-7xl mx-auto px-6 py-12">
        {/* Top Section: Logo, Navigation, and Social Media */}
        <div className="flex flex-col md:flex-row items-start md:items-center justify-between mb-12 pb-8 border-b border-gray-200">
          {/* Logo and Navigation */}
          <div className="flex flex-col md:flex-row items-start md:items-center gap-6 mb-6 md:mb-0">
            {/* Logo */}
            <Link to="/" className="flex-shrink-0">
              <img
                src={logo}
                alt="Ojoto Union Logo"
                className="w-16 h-16 object-cover"
              />
            </Link>

            {/* Main Navigation Links */}
            <div className="flex flex-wrap items-center gap-6">
              {mainNavLinks.map((link, index) => (
                <Link
                  key={index}
                  to={link.path}
                  className="text-sm font-semibold transition-all duration-200 relative"
                  style={{
                    color: '#374151',
                    textDecoration: 'none',
                    fontFamily: "'Open Sans', system-ui, sans-serif",
                    fontWeight: 600
                  }}
                  onMouseEnter={(e) => {
                    e.target.style.color = '#1E40AF';
                    e.target.style.transform = 'translateX(4px)';
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.color = '#374151';
                    e.target.style.transform = 'translateX(0)';
                  }}
                >
                  {link.name}
                </Link>
              ))}
            </div>
          </div>

          {/* Social Media Icons */}
          <div className="flex items-center gap-3">
            {socialLinks.map((social, index) => (
              <a
                key={index}
                href={social.url}
                target="_blank"
                rel="noopener noreferrer"
                className="w-11 h-11 rounded-full flex items-center justify-center transition-all duration-200 shadow-md"
                style={{
                  backgroundColor: '#1E40AF',
                  color: '#FFFFFF'
                }}
                onMouseEnter={(e) => {
                  e.target.style.backgroundColor = '#F59E0B';
                  e.target.style.transform = 'scale(1.15) translateY(-2px)';
                  e.target.style.boxShadow = '0 4px 12px rgba(245, 158, 11, 0.4)';
                }}
                onMouseLeave={(e) => {
                  e.target.style.backgroundColor = '#1E40AF';
                  e.target.style.transform = 'scale(1) translateY(0)';
                  e.target.style.boxShadow = '0 2px 4px rgba(0, 0, 0, 0.1)';
                }}
                aria-label={social.label}
              >
                {social.icon}
              </a>
            ))}
          </div>
        </div>

        {/* Middle Section: Contact Info and Newsletter */}
        <div className="grid md:grid-cols-1 gap-12 mb-12">
          {/* Contact Information */}
          <div>
            <h4 
              className="text-base font-bold mb-3"
              style={{
                color: '#1F2937',
                fontFamily: "'Open Sans', system-ui, sans-serif",
                fontWeight: 700
              }}
            >
              Mailing Address
            </h4>
            <div 
              className="text-sm leading-relaxed"
              style={{
                color: '#6B7280',
                fontFamily: "'Open Sans', system-ui, sans-serif"
              }}
            >
              <p>P. O. Box 336</p>
              <p>Lanham, MD 20703</p>
              <p className="mt-2">Email: Akanasato@yahoo.com</p>
            </div>
          </div>
        </div>

        {/* Newsletter Signup */}
        <div className="mb-12">
          <h4 
            className="text-base font-bold mb-3"
            style={{
              color: '#1F2937',
              fontFamily: "'Open Sans', system-ui, sans-serif",
              fontWeight: 700
            }}
          >
            Sign Up for News
          </h4>
          <p 
            className="text-sm mb-4 leading-relaxed"
            style={{
              color: '#6B7280',
              fontFamily: "'Open Sans', system-ui, sans-serif",
              maxWidth: '600px'
            }}
          >
            Ojoto Union North America uses the contact information you provide to us to contact you about our relevant content, products and services. You may unsubscribe from these communications at anytime. For information on our commitment to protecting your privacy, check out our{" "}
            <Link 
              to="/privacy" 
              className="text-[#1E40AF] hover:underline"
              style={{ textDecoration: 'none' }}
            >
              Privacy Policy
            </Link>
            .
          </p>
          <form onSubmit={handleNewsletterSubmit} className="flex flex-col sm:flex-row gap-3 max-w-md">
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Email address"
              required
              className="flex-1 px-4 py-3 rounded-md border border-gray-300 focus:outline-none focus:ring-2 focus:ring-[#1E40AF] focus:border-transparent"
              style={{
                backgroundColor: '#F9FAFB',
                fontFamily: "'Open Sans', system-ui, sans-serif",
                fontSize: '14px'
              }}
            />
            <button
              type="submit"
              className="px-6 py-3 rounded-md font-bold uppercase text-sm transition-colors duration-200"
              style={{
                backgroundColor: '#C2410C',
                color: '#FFFFFF',
                fontFamily: "'Open Sans', system-ui, sans-serif",
                fontWeight: 700,
                whiteSpace: 'nowrap'
              }}
              onMouseEnter={(e) => {
                e.target.style.backgroundColor = '#9A3412';
              }}
              onMouseLeave={(e) => {
                e.target.style.backgroundColor = '#C2410C';
              }}
            >
              SUBSCRIBE
            </button>
          </form>
        </div>

        {/* Bottom Bar: Copyright and Legal Links */}
        <div className="border-t border-gray-200 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p 
              className="text-xs"
              style={{
                color: '#9CA3AF',
                fontFamily: "'Open Sans', system-ui, sans-serif"
              }}
            >
              © {currentYear} Ojoto Union North America | All Rights Reserved | EIN: 12-3456789
            </p>
            <div className="flex items-center gap-4 text-xs">
              <Link
                to="/privacy"
                className="transition-colors duration-200"
                style={{
                  color: '#6B7280',
                  fontFamily: "'Open Sans', system-ui, sans-serif",
                  textDecoration: 'none'
                }}
                onMouseEnter={(e) => {
                  e.target.style.color = '#1E40AF';
                }}
                onMouseLeave={(e) => {
                  e.target.style.color = '#6B7280';
                }}
              >
                Privacy Policy
              </Link>
              <span style={{ color: '#D1D5DB' }}>|</span>
              <Link
                to="/terms"
                className="transition-colors duration-200"
                style={{
                  color: '#6B7280',
                  fontFamily: "'Open Sans', system-ui, sans-serif",
                  textDecoration: 'none'
                }}
                onMouseEnter={(e) => {
                  e.target.style.color = '#1E40AF';
                }}
                onMouseLeave={(e) => {
                  e.target.style.color = '#6B7280';
                }}
              >
                Cookie Policy
              </Link>
              <span style={{ color: '#D1D5DB' }}>|</span>
              <Link
                to="/terms"
                className="transition-colors duration-200"
                style={{
                  color: '#6B7280',
                  fontFamily: "'Open Sans', system-ui, sans-serif",
                  textDecoration: 'none'
                }}
                onMouseEnter={(e) => {
                  e.target.style.color = '#1E40AF';
                }}
                onMouseLeave={(e) => {
                  e.target.style.color = '#6B7280';
                }}
              >
                Terms & Conditions
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
